import { useGetDealerBrandsQuery } from '@api/customer.api';
import { TextCodes } from '@api/types/translation/TextCodes';
import { getDealerPublicAddress } from '@store/dealer/dealer.slice';
import { t } from '@translations';
import { useSelector } from 'react-redux';
import { DealerCheckboxGroup } from './DealerCheckboxGroup';

export const DealerDetailsBrands = () => {
  const { isFetching, isLoading, currentData } = useGetDealerBrandsQuery();
  const dealerPublicAddress = useSelector(getDealerPublicAddress);

  return (
    <DealerCheckboxGroup
      label={t(TextCodes.Dealer.Details.Brands)}
      isItemListWorking={isFetching || isLoading}
      itemList={currentData?.data}
      checkedItemList={dealerPublicAddress?.brandsTranslatedLabels}
      type='brands'
    />
  );
};
